import { createContext, useContext, useState, useMemo } from 'react';

export const OnboardingContext = createContext();

export const OnboardingProvider = ({ children }) => {
  const [onboardingAnswers, setOnboardingAnswers] = useState(null);

  const value = useMemo(
    () => ({ onboardingAnswers, setOnboardingAnswers }),
    [onboardingAnswers]
  );

  return (
    <OnboardingContext.Provider value={value}>
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => useContext(OnboardingContext);
